import Typed from "typed.js";

const Intro = () => {
	const block = document.querySelectorAll(".intro");
	if (!block) {
		return;
	}
	const isMobile = window.innerWidth < 768;

	block.forEach((el) => {
		const subtitle = el.querySelector(".intro__title-item");
		const words = subtitle.getAttribute("data-words");
		const bg = el.querySelector(".intro__bg");

		const typed = new Typed(subtitle, {
			strings: words.split(","),
			startDelay: 0,
			typeSpeed: 20,
			backSpeed: 0,
			backDelay: 3000,
			loop: true,
			showCursor: false
		});

		if (isMobile) {
			// mobile_tablet video bg
			const video = document.createElement("video");
			video.src = bg.getAttribute("data-video");
			video.classList.add("intro__bg-video");
			video.setAttribute("muted", "");
			video.autoplay = true;
			video.muted = true;
			video.loop = true;
			video.setAttribute("preload", "auto");
			video.setAttribute("playsinline", "");
			if (!el.querySelector(".intro__bg-video")) {
				bg.appendChild(video);
				video.addEventListener('loadeddata', () => {
					video.play();
				});
			}
		} else {
			const script = document.createElement("script");
			script.classList.add("patch-script");
			script.src = bg.getAttribute("data-patch");
			if (!document.querySelector(".patch-script")) {
				document.body.appendChild(script);
			}

			// cables
			script.onload = () => {
				const canvas = document.createElement("canvas");
				canvas.setAttribute("id", "glcanvas");
				canvas.setAttribute("width", "100%");
				canvas.setAttribute("height", "100%");
				canvas.setAttribute("tabindex", "1");
				if (!bg.querySelector("canvas")) {
					bg.appendChild(canvas);
				}

				function showError(errId, errMsg) {
					// handle critical errors here if needed
				};
		
				function patchInitialized(patch) {
					// You can now access the patch object (patch), register variable watchers and so on
				};
		
				function patchFinishedLoading(patch) {
					// The patch is ready now, all assets have been loaded
				};
		
				document.addEventListener("CABLES.jsLoaded", function (event) {
					CABLES.patch = new CABLES.Patch({
						patch: CABLES.exportedPatch,
						"prefixAssetPath": "",
						"assetPath": "https://6187708.fs1.hubspotusercontent-na1.net/hubfs/6187708/_patch/images/",
						"jsPath": "https://6187708.fs1.hubspotusercontent-na1.net/hubfs/6187708/_patch/js/",
						"glCanvasId": "glcanvas",
						"glCanvasResizeToWindow": true,
						"onError": showError,
						"onPatchLoaded": patchInitialized,
						"onFinishedLoading": patchFinishedLoading,
						"canvas": {"alpha":true, "premultipliedAlpha":true }, // make canvas transparent
						"variables":{
							"Total Image Number" : 4
						}
					});
				});
		
				// disable rubberband effect on mobile devices
				el.querySelector("#glcanvas").addEventListener("touchmove", (e)=>{ e.preventDefault(); }, false);
			};
		}
	});
};

export default Intro;
